import precision from '../assets/precision.png';
import { useSharedState } from '../hooks/useSharedState';
import styles from './LocateMe.module.css';

interface LocateMeProps {
    latitude?: string;
    longitude?: string;
    onLocationChange?: (latitude: string, longitude: string) => void;
}

export function LocateMe({ latitude: controlledLatitude, longitude: controlledLongitude, onLocationChange }: LocateMeProps) {

    const [sharedLatitude, setSharedLatitude] = useSharedState('latitude', '');
    const [sharedLongitude, setSharedLongitude] = useSharedState('longitude', '');

    const latitude = controlledLatitude ?? sharedLatitude;
    const longitude = controlledLongitude ?? sharedLongitude;

    const setLocation = (nextLatitude: string, nextLongitude: string) => {
        if (onLocationChange) {
            onLocationChange(nextLatitude, nextLongitude);
            return;
        }

        setSharedLatitude(nextLatitude);
        setSharedLongitude(nextLongitude);
    };

    const toggleGeolocalization = () => {

        if(latitude && longitude) {
            setLocation('', '');
            return;
        }
        
        const success: PositionCallback = (position) => {

            const lat = position.coords.latitude.toString();
            const lng = position.coords.longitude.toString();

          setLocation(lat, lng);

          console.log("pos: ", lat, lng);
        }
      
        const error = (error: GeolocationPositionError) => {
          console.error(error);
        }
      
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {

        }
    }

    return <button
        type="button"
        onClick={toggleGeolocalization}
        className={[styles.container, latitude && longitude ? styles.selected : ''].join(' ')}
        aria-pressed={Boolean(latitude && longitude)}
    >

        <img src={precision} width="30" height="30" alt="" />
        Autour de moi
        {latitude && longitude && <span className={styles.checkBadge} aria-hidden="true">✓</span>}

    </button>;

}
